import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreditCardFlowPage } from './credit-card-flow.page';

const routes: Routes = [
  {
    path: '',
    component: CreditCardFlowPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreditCardFlowPageRoutingModule {}
